import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import classNames from 'classnames';
import { Carousel } from 'dibs-carousel';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { SharedCarouselDot } from '../sharedComponents/SharedCarouselDot/SharedCarouselDot.tsx';
import styles from './styles/ShopCarousel.scss';

function ShopCarouselComponent({ landingPage }) {
    const { hero } = landingPage;
    if (!hero) {
        return null;
    }
    const heroLength = (hero.items || []).length;
    return (
        <div className={styles.wrapper}>
            {!!heroLength && (
                <Carousel
                    dataTn="collections-carousel-item"
                    isAutoRun
                    showDots={heroLength > 1}
                    hideArrows
                    itemsPerPage={1}
                    step={1}
                    totalItems={heroLength}
                    renderItem={({ index, isVisible }) => {
                        const item = hero.items[index];
                        const linkPosition = item.linkPosition || 'center';
                        const imageClasses = classNames(styles.image, {
                            [styles.left]: linkPosition === 'left',
                            [styles.center]: linkPosition === 'center',
                            [styles.right]: linkPosition === 'right',
                        });

                        const image = (
                            <div
                                data-tn="collections-carousel-item-image"
                                className={imageClasses}
                                style={{ backgroundImage: `url(${item.imageUrl})` }}
                            />
                        );
                        return (
                            <div
                                className={styles.slideWrapper}
                                style={{ opacity: isVisible ? '1' : '0' }}
                            >
                                {!!item.imageUrl &&
                                    (item.url ? (
                                        <Link
                                            className={styles.imageWrapper}
                                            dataTn="collections-carousel-item-url"
                                            href={item.url}
                                        >
                                            {image}
                                        </Link>
                                    ) : (
                                        <span className={styles.imageWrapper}>{image}</span>
                                    ))}
                                {!!item.title && (
                                    <h3
                                        className={styles.slideTitle}
                                        data-tn="collections-carousel-item-title"
                                    >
                                        {item.title}
                                    </h3>
                                )}
                            </div>
                        );
                    }}
                    renderDot={({ isCurrentDot } = {}) => (
                        <SharedCarouselDot isActive={isCurrentDot} />
                    )}
                />
            )}
        </div>
    );
}

ShopCarouselComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopCarousel = createFragmentContainer(ShopCarouselComponent, {
    landingPage: graphql`
        fragment ShopCarousel_landingPage on LandingPage {
            ...ShopBreadcrumbs_landingPage
            hero {
                items {
                    imageUrl
                    url
                    linkPosition
                    title
                }
            }
        }
    `,
});
